module.exports = __webpack_public_path__ + "img/carshina21_12.6cd3a6c7.jpg";